// Global scope for asynchronously creating instances of YT after finishing loading Youtube Iframe video API
let resolveApiReady;

const youtubeApiLoaded = new Promise(resolve => {
  resolveApiReady = resolve
});

function onYouTubeIframeAPIReady() {
  if(resolveApiReady) resolveApiReady(YT);
}

// IIFE
 (function () {
    //Slide Part
    const arrowPath = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
    const slide = new Splide('#YouTubeVideoSlider', {
      arrowPath,
      perPage: 1,
      gap: '1em',
      mediaQuery: 'min',
    }).mount();

    slide.on('click', pauseAllMedia);
    slide.on('hidden', pauseHiddenSlideVideo);

    // message event listener

    addEventListener('message', messageEventCallback);

    // MessageEvent Function
    let currentPlayingVideoTextWrappers='', videoContentSegments='', currentActiveVideoId='';

    function messageEventCallback(event) {
      if(!event.origin.includes('youtube.com')) return;
      const data = JSON.parse(event.data);
      // console.log('data', data);
      if(data?.info?.videoData?.video_id) {
        if(currentActiveVideoId !== data.info.videoData.video_id) {
          // Reset
          currentPlayingVideoTextWrappers=''; 
          videoContentSegments='';
          currentActiveVideoId = data.info.videoData.video_id;

          // Get the deferred media element of current playing youtube video 
          const currentDeferredMedia = document.querySelector(`[data-media-id=${currentActiveVideoId}]`);
          const dataScript = currentDeferredMedia.parentElement.querySelector('.video-segments-data');
          if(dataScript) {
            videoContentSegments = JSON.parse(dataScript.textContent);
            currentPlayingVideoTextWrappers = currentDeferredMedia.closest('.review-video-section').querySelectorAll('.video-timestamp__text-wrapper');
          }
        }
      }
      
      if(!data.event === 'infoDelivery' || !data.info || !data.info.currentTime) return;
      const currentTime = data.info.currentTime;

      if(currentPlayingVideoTextWrappers === '' || videoContentSegments ==='') return;
      const currentSegment = videoContentSegments.find(segment => currentTime >=segment.start && currentTime <= segment.end);

      if(currentSegment) {
        currentPlayingVideoTextWrappers.forEach(textWrapper => {
          if(textWrapper.innerHTML !== currentSegment.html) textWrapper.innerHTML = currentSegment.html;
        })
      } else {
        currentPlayingVideoTextWrappers.forEach(textWrapper => {
          if(textWrapper.innerHTML !== '') textWrapper.innerHTML = ''
        })
      }
    }
   
    // TimeStamp function
    const reviewVideoContainers = document.querySelectorAll('.review-video-section');
    if(reviewVideoContainers.length) {
      reviewVideoContainers.forEach(container => {
        container.addEventListener('click', timestampCallback)
      })
    }

    function timestampCallback(e) {
      if(!e.target.classList.contains('timestamp')) return;
      const deferredMedia = e.currentTarget.querySelector('deferred-media');
      const iframeVideo = deferredMedia.querySelector('iframe');
      const videoTimestampWrapper = e.target.closest('.video-timestamp__wrapper');
      if(!videoTimestampWrapper) return;
      
      const timestamp = durationToSeconds(videoTimestampWrapper.dataset.timestamp);
      if(isNaN(timestamp)) return;

      if(!iframeVideo) {
        // If there is no video, inject the video and start at the clicked timestamp
        deferredMedia.loadContent(true, timestamp)
      } else {
        const player = deferredMedia.player;
        // player.mute();
        player.seekTo(timestamp, true);
        // player.playVideo();
        // player.unMute()
      }

      // Iframe video scroll into view
      scrollBy({top: deferredMedia.closest('.splide').getBoundingClientRect().top - document.querySelector('header').clientHeight -15 , behavior: 'smooth'});
      deferredMedia.closest('.review-video-slide__container').scrollTo({top: 0, behavior: 'smooth'})
    }

    // convert timestamp to seconds
    function durationToSeconds(timestamp) {
      return timestamp.split(':').reduce((acc, time) => (acc * 60) + Number(time), 0)
    }

    // IntersectionObserver Part
    const observer = new IntersectionObserver(intersectionCallback);
    observer.observe(document.querySelector('#YouTubeVideoSlider'));

    function intersectionCallback(entries) {
      entries.forEach(entry => {
        if(!entry.isIntersecting) pauseAllMedia()
      })
    }

    function pauseHiddenSlideVideo({slide}) {
      const videoIframe = slide.querySelector('.js-youtube');
      if(videoIframe) videoIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }  
    
  })();